import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const WebsitesPage = () =>
  import('@/apps/adok/pages/websites').then((m) => m.WebsitesPage)

const websitesRoutes: RouteRecordRaw[] = [
  {
    path: '/websites',
    component: Layout,
    children: [
      {
        path: '',
        name: 'websites',
        component: WebsitesPage,
        meta: {
          title: 'Websites'
        }
      },

      {
        path: 'new',
        name: 'websites-new',
        component: WebsitesPage,
        meta: {
          title: 'New Website',
          hidden: true
        }
      },
      {
        path: ':websiteId/master-spots/:masterSpotId/sets/:setId/spots/:spotId/edit',
        name: 'websites-master-spot-set-spot-edit',
        component: WebsitesPage,
        props: true,
        meta: {
          title: 'Edit Spot',
          hidden: true
        }
      },
      {
        path: ':websiteId/master-spots/:masterSpotId/sets/:setId/spots/new',
        name: 'websites-master-spot-set-spot-new',
        component: WebsitesPage,
        props: true,
        meta: {
          title: 'New Spot',
          hidden: true
        }
      },

      {
        path: ':websiteId/master-spots/:masterSpotId/sets/:setId/edit',
        name: 'websites-master-spot-set-edit',
        component: WebsitesPage,
        props: true,
        meta: {
          title: 'Edit Spot Set',
          hidden: true
        }
      },
      {
        path: ':websiteId/master-spots/:masterSpotId/sets/new',
        name: 'websites-master-spot-set-new',
        component: WebsitesPage,
        props: true,
        meta: {
          title: 'New Spot Set',
          hidden: true
        }
      },

      {
        path: ':websiteId/master-spots/:masterSpotId/edit',
        name: 'websites-master-spot-edit',
        component: WebsitesPage,
        meta: {
          title: 'Edit Master Spot',
          hidden: true
        }
      },
      {
        path: ':websiteId/master-spots/:masterSpotId/code',
        name: 'websites-master-spot-code',
        component: WebsitesPage,
        meta: {
          title: 'Master Spot Code',
          hidden: true
        }
      },
      {
        path: ':websiteId/master-spots/new',
        name: 'websites-master-spot-new',
        component: WebsitesPage,
        meta: {
          title: 'New Master Spot',
          hidden: true
        }
      },

      {
        path: ':websiteId/verification',
        name: 'websites-verification',
        component: WebsitesPage,
        meta: {
          title: 'Website Verification',
          hidden: true
        }
      },
      {
        path: ':websiteId/edit',
        name: 'websites-edit',
        component: WebsitesPage,
        meta: {
          title: 'Configure Website',
          hidden: true
        }
      }
    ]
  }
]

export default websitesRoutes
